<template>
  <SkCollapse class="quote-split-details__collapse">
    <template slot="labelLeft">
      <div class="quote-split-details__label-left">
        <span class="sk-text-large-semibold">
          {{ $t('quote_split_details.title') }}
        </span>
        <span class="sk-text-medium-regular text--grey">
          {{ subtitle }}
        </span>
      </div>
    </template>
    <template slot="content">
      <div class="quote-split-details__content">
        <ShopBillingSection
          v-for="shop in shops"
          :key="shop.name"
          :name="shop.name"
          :total-price-subscriptions="shop.totalPriceSubscriptions"
          :total-price-workspace="shop.totalPriceWorkspace"
          :total-price-features="shop.totalPriceFeatures"
          :total-price-charges="shop.totalPriceCharges"
          :total-without-tax="shop.totalWithoutTax"
          :announced-users="shop.announcedUsers"
          :payment-frequency="paymentFrequency"
        />
      </div>
    </template>
  </SkCollapse>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  extractPaymentFrequency,
  extractPrice,
} from '@/shared/utils/method_helper';

import ShopBillingSection from './ShopBillingSection.vue';

export default {
  name: 'QuoteSplitDetails',
  components: {
    ShopBillingSection,
  },
  props: {
    quote: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['isBillingSplitByShops', 'isBillingSplitByShopEmployees']),
    shops() {
      if (!this.isBillingSplitByShops && !this.isBillingSplitByShopEmployees) {
        return [];
      }

      if (!this.quote.split_line_items) {
        return [];
      }

      return this.quote.split_line_items.map(item => ({
        name: item.title,
        announcedUsers: this.isBillingSplitByShopEmployees ? item.announced_users : null,
        totalPriceSubscriptions: extractPrice(this.quote, item.total_price_subscriptions),
        totalPriceWorkspace: extractPrice(this.quote, item.total_price_workspace),
        totalPriceFeatures: extractPrice(this.quote, item.total_price_features),
        totalPriceCharges: item?.total_price_charges > 0 ?
          extractPrice(this.quote, item.total_price_charges) : null,
        totalWithoutTax: extractPrice(this.quote, item.total_without_tax),
      }));
    },
    paymentFrequency() {
      return extractPaymentFrequency(this.quote);
    },
    subtitle() {
      if (this.isBillingSplitByShops) {
        return this.$t('quote_split_details.subtitle_shops');
      }
      if (this.isBillingSplitByShopEmployees) {
        return this.$t('quote_split_details.subtitle_shop_employees');
      }
      return '';
    },
  },
};
</script>

<style lang="scss">
@use '@/shared/components/QuoteDetailsUniquePricing/shared' as *;

.quote-split-details__collapse {
  border: 1px solid $sk-grey-10;
  border-radius: 8px;
  margin-bottom: 24px;
}

.quote-split-details__label-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.quote-split-details__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0px 16px 16px 16px;
}
</style>
